import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    incidents: null,
    loading: false,
    error: null,
    updateGrid: false,
    pageNumber: 1,
    pageSize: 10
};
export const fetchIncidentsByAssetId = createAsyncThunk('IncidentByAssetId/fetchIncidentsByAsset', async ({ assetId, isManuallyEntered, pageNumber, pageSize }, { getState, rejectWithValue }) => {
    const state = getState();
    try {
        const response = await itwApi.get('Assets/get-incidents-by-asset-id', {
            params: {
                assetDetailId: assetId,
                isManuallyEntered,
                pageNumber,
                pageSize
            }
        });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch incidents by asset ID');
    }
});
export const fetchIncidentPdf = createAsyncThunk('asset/fetchAssetReport', async (assetId, { rejectWithValue }) => {
    if (!assetId) {
        return rejectWithValue('AssetId is required');
    }
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await itwApi.get(`Assets/generate-assets-report?AssetId=${assetId}`, {
            responseType: 'blob',
            headers: {
                Accept: 'application/pdf',
                'X-TimeZone': timeZone
            }
        });
        // Check if the blob is actually a PDF (basic validation)
        const contentType = response.headers['content-type'];
        if (contentType !== 'application/pdf') {
            return rejectWithValue('Unexpected file type received.');
        }
        // Check if the blob has size
        if (!response.data || response.data.size === 0) {
            return rejectWithValue('Received empty file.');
        }
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Asset_Manual_Entry_Report_${new Date().toISOString()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return true;
    }
    catch (error) {
        const message = error?.response?.data?.message || error?.message || 'Failed to download PDF file.';
        return rejectWithValue(message);
    }
});
export const incidentByAseetIdSlice = createSlice({
    name: 'systemDetail',
    initialState,
    reducers: {
        clearIncidentsByAssetId: (state) => {
            state.incidents = null;
        },
        setIsUpdateGrid: (state) => {
            state.updateGrid = !state.updateGrid;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        resetPagination: (state) => {
            state.pageNumber = 1;
            state.pageSize = 10;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchIncidentsByAssetId.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchIncidentsByAssetId.fulfilled, (state, action) => {
            state.loading = false;
            state.incidents = action.payload;
        })
            .addCase(fetchIncidentsByAssetId.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'An error occurred';
        })
            .addCase(fetchIncidentPdf.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchIncidentPdf.fulfilled, (state) => {
            state.loading = false;
        })
            .addCase(fetchIncidentPdf.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});
export const { clearIncidentsByAssetId, setIsUpdateGrid, setPageNumber, setPageSize, resetPagination } = incidentByAseetIdSlice.actions;
export default incidentByAseetIdSlice.reducer;
